module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/svg--chevron-down-black-97abeb78.svg";